import $ from "jquery"

$(document).ready(function() {
    $('.js-areas-content-base.areas__heading--active').css('height', ($('.js-areas-content-base.areas__heading--active .areas__description').height())+80);
});
$('.js-areas-heading-desktop').each(function(){
    $(this).on('click', function(){
        const baseContent = $(this).closest('.areas__box').find('.js-areas-content-base').html();
        
        $('.js-areas-heading-desktop, .js-areas-heading-mobile').removeClass('areas__heading--active');
        $('.js-areas-sidebar').html(baseContent);

        $(this).addClass('areas__heading--active');
        $(this).closest('.areas__box').find('.js-areas-heading-mobile').addClass('areas__heading--active');
    });
});
$('.js-areas-heading-mobile').each(function(){
    $(this).on('click', function(){
        if ($(this).hasClass('areas__heading--active')) {
            $('.js-areas-heading-desktop, .js-areas-heading-mobile, .js-areas-content-base').removeClass('areas__heading--active').css('height', '');
        } else {
            const baseContent = $(this).closest('.areas__box').find('.js-areas-content-base').html();
            const areasContentBase = $(this).closest('.areas__box').find('.js-areas-content-base');
            
            $('.js-areas-heading-desktop, .js-areas-heading-mobile, .js-areas-content-base').removeClass('areas__heading--active').css('height', '');
            $('.js-areas-sidebar').html(baseContent);
    
            $(this).addClass('areas__heading--active');
            $(this).closest('.areas__box').find('.js-areas-heading-desktop').addClass('areas__heading--active');
            areasContentBase.addClass('areas__heading--active');
            areasContentBase.css('height', (areasContentBase.children('.areas__description').height())+80);

            $('html, body').animate({
                scrollTop: $(this).closest('.areas__box').offset().top - 330
            }, 0);
        }
    });
});